/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  msgError: '',
  status: '',
};
export const currentUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.CURRENT_USER + '_LOADING':
      return {
        ...state,
        isLoading: true,
        status: ''
      };
    case actionType.CURRENT_USER + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        isLoading: true, // set loading cause need to refresh page
        isError: false,
        msgError: '',
        status: action.result.status,
      };
    case actionType.CURRENT_USER + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
        status: action.result.status,
      };
    case actionType.CURRENT_USER + '_ERROR':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
        status: action.status,
      };
    default:
      return state;
  }
};
